import { css } from '@emotion/react';
import { threeQuartersSpacing } from 'styles/global_defaults/scaffolding';

export const ROW_HEIGHT = 66;

export const communicationCustomStyles = css`
  min-height: ${ROW_HEIGHT}px;
  padding: ${threeQuartersSpacing}px 0;
`;
